import React, { Component } from 'react';
import Slider from "rc-slider";


class InputSlider extends Component {
    render() {
        const { onChangeHandler, isValue, max=250, min = 100 } = this.props;
        return  <Slider
                onChange={onChangeHandler}
                trackStyle={{ background: "var(--brand-gradient)" }}
                value={isValue}
                min={min}
                max={max}
            />
    }
}

export default InputSlider;